import { HorizontalBar } from 'vue-chartjs'

export default {
  name: 'hbar-chart',
  mixins: [HorizontalBar]
}
